export const openGameInHybrid888App = (url: string) => {
  window.webkit?.messageHandlers?.cbCallBackHandlerCGP?.postMessage(
    JSON.stringify({
      Func: 'OpenSecondWebView',
      url,
      closebut: 'false', // Game should be closed using "Exit Game" button from navbar to close it
    })
  );
};
